import axios from 'axios';
import { SpotlightBatchModel } from '../Models/SpotlightBatchModel';

const updateSpotlightBatch = (batch: SpotlightBatchModel) => axios.patch(`classifications/categories/${batch.categoriesId[0]}/spotlights/update-batch`, batch);

export default { 
    updateSpotlightBatch
};
